const images = [
  "/Assets/avatar1.png",
  "/Assets/avatar2.png",
  "/Assets/avatar3.png",
  "/Assets/avatar4.png",
  "/Assets/avatar5.png",
  "/Assets/avatar6.png",
  "/Assets/avatar7.png",
  "/Assets/avatar8.png",
  "/Assets/avatar9.png",
  "/Assets/avatar10.png",
  "/Assets/avatar11.png",
  "/Assets/avatar12.png",
  "/Assets/avatar13.png",
  "/Assets/avatar14.png",
  "/Assets/avatar15.png",
  "/Assets/avatar16.png",
  "/Assets/avatar17.png",
];

export default images;
